import { Button } from '@mui/material';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ISupportCase, ConfirmModal, useHasPermission, PermissionKeys } from '../../../shared';
import { useDeleteSupportCase } from '../../hooks';

export const DeleteSupportCaseAction: FC<{ supportCase?: ISupportCase }> = ({ supportCase }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { hasPermission } = useHasPermission();
    const hasWritePermission = hasPermission(PermissionKeys.SUPPORT_CASES_WRITE);

    const { mutateAsync: deleteSupportCase } = useDeleteSupportCase();

    const onDelete = useCallback(async () => {
        if (supportCase) {
            await deleteSupportCase(supportCase.id);
            navigate('/support');
        }
    }, [deleteSupportCase, navigate, supportCase]);

    if (supportCase && hasWritePermission) {
        return (
            <ConfirmModal
                onConfirm={onDelete}
                button={
                    <Button color="primary" variant="outlined" data-testid="deleteSupportCase" sx={{ mr: 2 }}>
                        {t('delete')}
                    </Button>
                }
                title={t('supportCaseDeleteWarningTitle')}
                text={t('supportCaseDeleteWarningText')}
            />
        );
    }
};
